<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
      <div role="tabpanel">
        <ul id="fileserviceTabs" class="nav nav-tabs bar_tabs pull-right" role="tablist">
          <li role="presentation">
            <a href="#uploadTab" data-toggle="tab"><i class="fas fa-file-upload"></i> {{ $t('upload_new') }}</a>
          </li>
          <li role="presentation">
            <a href="#detailTab" data-toggle="tab"><i class="fas fa-table"></i> {{ $t('detail') }}</a>
          </li>
          <li role="presentation">
            <a href="#overviewTab" data-toggle="tab" class="active"><i class="fas fa-table"></i> {{ $t('overview') }}</a>
          </li>
        </ul>
        <div id="fileserviceTabContent" class="tab-content">
          <div class="tab-pane" id="uploadTab">
            <fileupload ref="fileUploader" v-on:fileUploaded="reloadTable()"></fileupload>
          </div>
          <div class="tab-pane" role="tabpanel" id="detailTab">
            <filedetails :fileId="loadFileId" ref="fileEditor" :loadedFileId.sync="loadFileId" :loadedFileStatus.sync="loadedFileStatus" v-on:fileSaved="reloadTable()"></filedetails>
          </div>
          <div class="tab-pane active" role="tabpanel" id="overviewTab">
            <!--- Left panel with open files -->
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="card">           
                <div class="card-content">
                  <v-server-table :url="tableDataUrl" :columns="columns" ref="fileserviceTable" :options="options">
                    <template slot="status" slot-scope="props">
                        <span class="text-center blockdisplay statusIcon">
                        <span v-if="props.row.status == 'completed'" class="text-success" data-tooltip="Completed"><i class="fas fa-check-circle"></i>  {{ $t('completed') }}</span> 
                        <span v-if="props.row.status == 'pending' && !props.row.user_id" class="text-pending" data-tooltip="Pending"><i class="fas fa-clock"></i>  {{ $t('pending') }}</span> 
                        <span v-if="props.row.status == 'canceled'" class="text-error" data-tooltip="Can't do / error"><i class="fas fa-times"></i>  {{ $t('canceled') }}</span>
                        <span v-if="props.row.status == 'take_longer'" class="text-warning" data-tooltip="Takes longer"><i class="fas fa-times"></i>  {{ $t('take_longer') }}</span>
                        <span v-if="props.row.user_id && props.row.status !== 'completed' && props.row.status !== 'canceled'">
                          <i class="fas fa-wrench text-pending"></i> {{ $t('in_progress') }}
                        </span>
                        </span>
                    </template>
                    <template slot="instructions" slot-scope="props">
                      <div style="max-width:500px;" v-for="(childFile) in props.row.children"><i class="far fa-comment"></i> {{ childFile.admin_notes }}<br/></div>
                    </template>
                    <template slot="child_row" slot-scope="props" class="fileservice-child-row" v-if="props.row.status == 'completed'">
                      <table width="100%" class="table table-hover fsTableFileList" v-if="props.row.children" v-for="(childFile) in props.row.children">
                        <tr v-if="childFile.files" v-for="(file, key) in childFile.files">
                          <th scope="row" style="vertical-align:top; width:100px;">Archivo {{ parseInt(key + 1) }}</th>
                          <td><i class="fas fa-file-code"></i> {{ file.name }}<br/><i class="fas fa-comment-dots"></i> {{ childFile.admin_notes }}</td>
                          <td width="150"><a href="#" @click="downloadFiles(childFile.id, file.name)" class="btn btn-primary"><i class="fas fa-download fa-lg"></i></a></td>
                        </tr>
                        </table>
                        <em v-if="props.row.details.status_updates"><strong>{{ $t('special_instructions') }}:</strong> {{ props.row.details.status_updates }}</em>
                        <em v-if="props.row.admin_notes"><strong>{{ $t('special_instructions') }}:</strong> {{ props.row.admin_notes }}</em>
                    </template>
                    <template slot="child_row" slot-scope="props" class="fileservice-child-row"  v-if="props.row.status == 'take_longer'">
                      <h5>{{ $t('status_updates') }}</h5>
                      <table class="table-responsive table-hover fsTableFileList" v-if="props.row.details.status_updates">
                        <tr  v-for="(statusUpdate) in props.row.details.status_updates" :key="statusUpdate">
                          <td>{{ statusUpdate.date|dateFilter }} <strong>{{ $t(statusUpdate.status.toLowerCase()) }}</strong></td>
                          <td style="padding-left: 15px"><i class="fas fa-comment-dots"></i> {{ statusUpdate.message }}</td>
                        </tr>
                        </table>
                    </template>
                    <template slot="serieName" slot-scope="props">
                      <div v-if="props.row.vin">VIN: {{props.row.vin}}</div>
                      <span v-if="props.row.brandName">
                          {{ props.row.brandName }} > 
                        </span>
                      <span v-if="props.row.serieName">
                          {{ props.row.serieName }} > 
                      </span>
                      <span v-if="props.row.details.vehicle_details">
                        
                        <span v-if="props.row.details.vehicle_details.series">
                          {{props.row.details.vehicle_details.series }} > 
                        </span>
                        <span v-if="props.row.details.vehicle_details.build">
                          {{props.row.details.vehicle_details.build }} > 
                        </span>
                        <span v-if="props.row.details.vehicle_details.engine">
                          {{props.row.details.vehicle_details.engine }} | 
                        </span>
                        <span v-if="props.row.details.vehicle_details.year">
                          {{props.row.details.vehicle_details.year }}
                        </span>
                        <span v-if="props.row.details.vehicle_details.hp">
                           > {{props.row.details.vehicle_details.hp }} {{ $t('hp') }}
                        </span>
                      </span>
                      <span v-else>
                      {{ props.row.brandName }} > {{ props.row.serieName }} > {{ props.row.engineName}} | 
                      <span v-if="(props.row.details.vehicle_details) && (props.row.details.vehicle_details.year)">
                          {{props.row.details.vehicle_details.year }}
                        </span>
                      </span>
                    </template>
                    <template slot="actions" slot-scope="props"  v-if="props.row.status == 'completed'">
                      <a @click="downloadFiles(props.row.id)" class="btn btn-primary"><i class="fas fa-file-archive"></i> {{ $t('download_all_as_zip') }}</a>
                      <a @click="editRow(props.row.id)" class="btn btn-primary"><i class="fas fa-search"></i> {{ $t('file_details') }}</a>
                    </template>
                    </v-server-table>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Filedetails from '../../components/file'
import Fileupload from '../../components/upload'
import swal from 'sweetalert2'
export default {
  components: {
    Filedetails,
    Fileupload
  },
  data: function () {
    return {
    customer: '',
    openFileOnLoadId: this.$route.params.fileId,
    showTab: this.$route.params.tab,
    loadedFileStatus: false,
    loadFileId: '',
    tableDataUrl: APIURL + '/files',
    columns: ['status', 'instructions', 'created_at', 'serieName', 'product', 'actions'],
    options: {
        headings: {
          'status' : this.$t('Status'),
          'created_at' : this.$t('information'),
          'serieName' : this.$t('Vehicle'),
          'product' : this.$t('Product'),
          'actions' : this.$t('Actions'),
          'instructions': this.$t('Engineer instructions'),
        },
        perPage: 10,
        rowClassCallback: function(row) {
            if(row.status == 'pending') {
            return 'fileOverviewRowPending';
            }
            if(row.status == 'completed') {
            return 'fileOverviewRowFinished';
            }
            if(row.status == 'canceled') {
            return 'fileOverviewRowCanceled';
            }
        }
    },
    }
  },
  mounted: function () {
    Webservice.getUser().then(resp => {
      this.customer = resp.data;
    });
    if(this.showTab == 'upload') {
      $('.nav-tabs a[href="#uploadTab"]').tab('show');
    }
    if(this.openFileOnLoadId) {
      this.loadedFileStatus = true;
      var fileEditor = this.$refs.fileEditor;
      this.fileLoaded = 'untouched';
      this.loadFileId = id;
      fileEditor.loadFileDetails(id);
      $('.nav-tabs a[href="#detailTab"]').tab('show');
    }
  },
  methods: {
    reloadTable() {
      this.$refs.fileserviceTable.getData();
      $("html, body").animate({ scrollTop: 0 }, "fast");
      this.loadedFileStatus = false;
      $('.nav-tabs a[href="#overviewTab"]').tab('show');
    },
    editRow(id) {
      this.loadedFileStatus = true;
      var fileEditor = this.$refs.fileEditor;
      this.fileLoaded = 'untouched';
      this.loadFileId = id;
      fileEditor.loadFileDetails(id);
      $('.nav-tabs a[href="#detailTab"]').tab('show');
    },
    downloadFiles(fileId, filename) {
        Webservice.downloadFile(fileId, filename).then((resp) => {
          if(resp.data.byteLength == 19) { /* this length is equivalent to "error_low_balance" */
            swal({
                title:
                  "No credits.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success btn-fill",
                html:
                  "You haven't downloaded this file before and your credit balance is too low.<br/><br/>Click <a href='/portal/credits'>here to buy new credits</a>"
              });
          }
          else if(resp.data.byteLength == 25) { /* this length is equivalent to "error_low_balance" */
            swal({
                title:
                  "Please contact your account manager about their credits!",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success btn-fill",
                html:
                  "This file hasn't been downloaded before and the credits of your account manager need to be upgraded.<br/><br/>Please contact them or send a ticket to support.</a>"
              });
          } else {
        if(resp.headers) {
                var headers = resp.headers;
                var a = document.createElement('a');
                let contenttype = resp.headers["content-type"];
                
                var blob = new Blob([resp.data], {type: contenttype});
                var url = window.URL.createObjectURL(blob);

                a.style = "display: none";  
                a.href = url;
                if(typeof(filename) === 'undefined') {
                  filename = 'archive_download_' + fileId;
                }
                a.download = filename;

                document.body.appendChild(a);
                a.click();
                setTimeout(function(){
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);  
              }, 1500);
            }
            }
        });
      },
      viewDetails(fileId) {
        Webservice.getFileDetails(fileId).then((resp) => {
              $('#exampleModalCenter').modal('toggle')
        }).catch((err) => {

        })
      }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Fileservice/Overview.vue